import React from 'react';
import { expandWithNestedExpand, expandWithNestedExpandLocalId, nestedExpand, nestedExpandWithLocalId } from '@atlaskit/adf-schema';
import { ACTION, ACTION_SUBJECT, ACTION_SUBJECT_ID, EVENT_TYPE, INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { FORMAT_MENU_ITEM, FORMAT_EXPAND_MENU_ITEM, FORMAT_NESTED_MENU_RANK, FORMAT_NESTED_MENU_RANK_REVISED } from '@atlaskit/editor-common/block-menu';
import { toolbarInsertBlockMessages as messages } from '@atlaskit/editor-common/messages';
import { IconExpand } from '@atlaskit/editor-common/quick-insert';
import { createWrapSelectionTransaction } from '@atlaskit/editor-common/utils';
import { fg } from '@atlaskit/platform-feature-flags';
import { expValEqualsNoExposure } from '@atlaskit/tmp-editor-statsig/exp-val-equals-no-exposure';
import { createExpandBlockMenuItem } from '../ui/ExpandBlockMenuItem';
import { createExpandNode, insertExpand, insertExpandWithInputMethod, toggleExpandWithMatch as _toggleExpandWithMatch, wrapSelectionAndSetExpandedState } from './commands';
import { expandKeymap } from './pm-plugins/keymap';
import { createPlugin } from './pm-plugins/main';
import { getToolbarConfig } from './toolbar';

// Ignored via go/ees005
// eslint-disable-next-line prefer-const
export var expandPlugin = function expandPlugin(_ref) {
  var _ref$config = _ref.config,
    options = _ref$config === void 0 ? {} : _ref$config,
    api = _ref.api;
  if (expValEqualsNoExposure('platform_editor_block_menu', 'isEnabled', true)) {
    var _api$blockMenu;
    api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 || _api$blockMenu.actions.registerBlockMenuComponents([{
      type: 'block-menu-item',
      key: FORMAT_EXPAND_MENU_ITEM.key,
      parent: {
        type: 'block-menu-section',
        key: FORMAT_MENU_ITEM.key,
        rank: fg('platform_editor_block_menu_format_rank_revised') ? FORMAT_NESTED_MENU_RANK_REVISED[FORMAT_EXPAND_MENU_ITEM.key] : FORMAT_NESTED_MENU_RANK[FORMAT_EXPAND_MENU_ITEM.key]
      },
      component: createExpandBlockMenuItem(api)
    }]);
  }
  return {
    name: 'expand',
    nodes: function nodes() {
      return [{
        name: 'expand',
        node: fg('platform_editor_adf_with_localid') ? expandWithNestedExpandLocalId : expandWithNestedExpand
      }, {
        name: 'nestedExpand',
        node: fg('platform_editor_adf_with_localid') ? nestedExpandWithLocalId : nestedExpand
      }];
    },
    actions: {
      insertExpand: insertExpand(api),
      insertExpandWithInputMethod: insertExpandWithInputMethod(api)
    },
    commands: {
      toggleExpandWithMatch: function toggleExpandWithMatch(selection) {
        return _toggleExpandWithMatch(selection);
      }
    },
    pmPlugins: function pmPlugins() {
      return [{
        name: 'expand',
        plugin: function plugin(_ref2) {
          var _options$allowInterac;
          var dispatch = _ref2.dispatch,
            getIntl = _ref2.getIntl,
            nodeViewPortalProviderAPI = _ref2.nodeViewPortalProviderAPI;
          return createPlugin(dispatch, getIntl, options.appearance, options.useLongPressSelection, api, nodeViewPortalProviderAPI, (_options$allowInterac = options.allowInteractiveExpand) !== null && _options$allowInterac !== void 0 ? _options$allowInterac : true, options.__livePage);
        }
      }, {
        name: 'expandKeymap',
        plugin: function plugin() {
          return expandKeymap(api, {
            __livePage: options.__livePage
          });
        }
      }];
    },
    pluginsOptions: {
      floatingToolbar: getToolbarConfig(api),
      quickInsert: function quickInsert(_ref3) {
        var formatMessage = _ref3.formatMessage;
        if (options && options.allowInsertion !== true) {
          return [];
        }
        return [{
          id: 'expand',
          title: formatMessage(messages.expand),
          description: formatMessage(messages.expandDescription),
          keywords: ['accordion', 'collapse'],
          priority: 600,
          icon: function icon() {
            return /*#__PURE__*/React.createElement(IconExpand, null);
          },
          action: function action(insert, state) {
            var _api$analytics;
            var node = createExpandNode(state, undefined, !!(api !== null && api !== void 0 && api.localId));
            if (!node) {
              return false;
            }
            var tr = state.selection.empty ? insert(node) : fg('platform_editor_adf_with_localid') ? wrapSelectionAndSetExpandedState(state, node) : createWrapSelectionTransaction({
              state: state,
              type: node.type
            });
            api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.attachAnalyticsEvent({
              action: ACTION.INSERTED,
              actionSubject: ACTION_SUBJECT.DOCUMENT,
              actionSubjectId: node.type === state.schema.nodes.nestedExpand ? ACTION_SUBJECT_ID.NESTED_EXPAND : ACTION_SUBJECT_ID.EXPAND,
              attributes: {
                inputMethod: INPUT_METHOD.QUICK_INSERT
              },
              eventType: EVENT_TYPE.TRACK
            })(tr);
            return tr;
          }
        }];
      }
    }
  };
};